import { PargodaRoundButton, styled } from "../../base";

export const LoginButton = styled(PargodaRoundButton)(({ theme }) => ({
    width: '-webkit-fill-available',
    height: theme.spacing(6),
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
}));

export const LineWithText = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    margin: `${theme.spacing(2.5)} 0`,

    '&::before': {
        content: '""',
        flex: 1,
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        marginInlineEnd: theme.spacing(5),
    },

    '&::after': {
        content: '""',
        flex: 1,
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        marginInlineStart: theme.spacing(5),
    },

    span: {
        padding: `0 ${theme.spacing(1.25)}`,
        background: theme.palette.common.white, // Match the background color of your container
    },
}));